import { useContext, useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { UserdataContext } from '../../../../App'
import { Job, listJobs } from '../../../../insfrastructure/services/jobs'
import { ListResponse } from '../../../../insfrastructure/services/utils'
import { formatDate } from '../../../../insfrastructure/utils/date-formatter'
import { listJobApplies } from '../../../../insfrastructure/services/job-applies'
import { StaticValues } from '../../../../insfrastructure/services/static_values'
import { TokenParams } from '../../../../insfrastructure/services/auth'
import { parseJwt } from '../../../../insfrastructure/utils/JWTParser'
import infoIcon from '../../../../assets/icons/info.png'
import searchIcon from '../../../../assets/icons/search.png'
import filterIcon from '../../../../assets/icons/filter.png'
import storageIcon from '../../../../assets/icons/storage.png'
import plusIcon from '../../../../assets/icons/plus.png'
import editIcon from '../../../../assets/icons/edit.png'
import peopleIcon from '../../../../assets/icons/people.png'
import duplicateIcon from '../../../../assets/icons/duplicate.png'
import deleteIcon from '../../../../assets/icons/delete.svg'
import openedEyeIcon from '../../../../assets/icons/opened_eye.svg'
import Table from '../../../components/table'
import JobDeleteModal from './job-delete-modal'
import './styles.sass'


const JobOffers = () => {
  const {userData} = useContext<any>(UserdataContext)
  const [searchParams, setSearchParams] = useSearchParams()
  const [offers, setOffers] = useState<ListResponse<Job>>({
    results: [],
    count: 0
  })
  const [hiredOffersCount, setHiredOffersCount] = useState(0)
  const [offset, setOffset] = useState(0)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [jobStatus, setJobStatus] = useState<Record<string, any>>({})
  const [parsedJWT, setParsedJWT] = useState<TokenParams>()
  const [selectedItemToDelete, setSelectedItemToDelete] = useState<any | null>(null)

  useEffect(() => {
    onParseJWT();
  }, [])
  

  useEffect(() => {
    if (!parsedJWT) {
      return;
    };

    listOffers({ 
      offset: searchParams.get('page') ? (parseInt(searchParams.get('page')+'') - 1) * 10 : 0,
      search: searchParams.get('search')
    });
    getStaticValues();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parsedJWT, searchParams])

  const onParseJWT = async () => {
    try {  
      const parsedJWT: TokenParams = parseJwt(localStorage.getItem('auth_token')+'');
      
      setParsedJWT(parsedJWT);
    } catch (error) {}
  }

  const listOffers = async ({offset, search}: Record<string, any>) => {
    try {
      setLoading(true);
      setOffers({
        results: [],
        count: 0
      });

      let params: any = { offset, limit: 10 };
      let hiredJobsParams: any = { status: 'HIRED', offset: 0, limit: 1 };
      let urlParams: any = {page: (offset / 10) + 1 + ''};

      if (search) {
        params.search = search;
        urlParams.search = search;
      };

      if (parsedJWT?.manager_id && !parsedJWT.profiles.includes('em_job_manager')) {
        params.managerId = parsedJWT?.manager_id;
        hiredJobsParams.managerId = parsedJWT?.manager_id;
      };

      const offersResults = (await listJobs(params));

      await Promise.all(offersResults.data.map(async x => {
        x.status = x.status.toLowerCase();
        x.candidates_quantity = (await listJobApplies(x.jobpostId)).length;
      }));

      setOffers({
        results: offersResults.data,
        count: offersResults.totalCount
      });
      setHiredOffersCount((await listJobs(hiredJobsParams)).totalCount);

      setOffset(offset);
      setSearch(search);
      setSearchParams(urlParams);
      
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }

  const getStaticValues = async () => {
    try {  
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
        const job_status = staticValues.job_status;
        
        setJobStatus(job_status);
      }, 1000);
    } catch (error) {}
  }

  const onSearch = async () => {
    listOffers({ offset: 0, search });
  }

  const onDeleteJob = async () => {
    setSelectedItemToDelete(null);
    listOffers({ 
      offset: searchParams.get('page') ? (parseInt(searchParams.get('page')+'') - 1) * 10 : 0,
      search: searchParams.get('search')
    });
  }

  return (
      <div className='job-offers company-page'>
        <div className='block'>
            <div className='block-header'>
              <div className='title'>
                <img src={storageIcon} alt='offers' />
                <h3>Vagas</h3>
              </div>
              {userData?.usertype === 'job_manager' &&
              <Link to='/offers/create'>
                <button className='primary add-btn'>
                  <img src={plusIcon} alt='add-offer' />
                  <span>Criar vaga</span>
                </button>
              </Link>}
            </div>
            {
              userData?.usertype === 'job_manager' &&
              <div className='general-vision'>
                <div className='data'>
                  <h3>Visão Geral</h3>
                  <h4>Total de vagas: <b>{ offers.count }</b></h4>
                  <h4>Vagas preenchidas: <b>{ hiredOffersCount }</b></h4>
                </div>
                <div className='graph-container'>
                  <CircularChart percentage={!loading && !Number.isNaN(hiredOffersCount / offers.count * 100) ? hiredOffersCount / offers.count * 100 : 0} />
                  <h4>Empregabilidade</h4>
                </div>
              </div>
            }
            <div className='oportunities-searcher'>
              <img className='search-icon' src={searchIcon} alt='search' onClick={onSearch} />
              <input type='text' placeholder='Pesquisar vaga' value={search} onChange={e => setSearch(e.target.value)} />
              <img className='filter-icon' src={filterIcon} alt='filter' />
            </div>
            <div className='offers'>
                <div className='job-results'>
                  <Table
                  data={offers.results}
                  total={offers.count}
                  limit={10}
                  offset={offset}
                  loading={loading}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  onNavigate={(params: any) => {
                    listOffers({ offset: params.offset, search });
                  }}
                  header={
                  <thead>
                    <tr>
                      <th className='name'>Nome da vaga:</th>
                      <th>Data de publicação:</th>
                      <th>Status:</th>
                      {userData?.usertype === 'job_manager' && <th>Candidatos:</th>}
                      {userData?.usertype === 'job_manager' && <th className='see-candidates'>Ver candidatos</th>}
                      <th className='actions'>
                        <div className="tooltip">
                          <div>
                            <span>Acessar vaga</span>
                            <img src={infoIcon} alt='info-icon' />
                          </div>
                          <span className="tooltiptext">Só é possivel editar vagas sem candidaturas. Para editar, exclua esta vaga e crie uma nova com a informação correta.</span>
                        </div>
                      </th>
                      {userData?.usertype === 'job_manager' && <th>Excluir vaga</th>}
                      {userData?.usertype === 'job_manager' && <th>Duplicar:</th>}
                    </tr>
                  </thead>}
                  body={
                    (offers: any) => {
                      return offers.map((offer: any, index: number) =>
                      <tr key={'tr_'+index}>
                        <td>{offer.jobTitle['name']}</td>
                        <td>{formatDate(offer.publishDate)}</td>
                        <td>
                          <span className={
                            'status '+offer.status
                          }>{ jobStatus[offer.status] }</span>
                        </td>
                        {userData?.usertype === 'job_manager' && <td>{offer.candidates_quantity}</td>}
                        {userData?.usertype === 'job_manager' &&
                        <td>
                          <Link to={'/offers/'+offer.jobpostId+'/candidates'}>
                            <img className='people-icon' alt='candidates' src={peopleIcon} />
                          </Link>
                        </td>}
                        <td>
                          {userData?.usertype === 'candidate' && 
                          <Link to={'/offers/'+offer.jobpostId+'/details'}>
                            <img className='edit-icon' alt='edit' src={editIcon} />
                          </Link>}
                          {userData?.usertype === 'job_manager' && !offer.candidates_quantity &&
                          <Link to={'/offers/'+offer.jobpostId}>
                            <img className='edit-icon' alt='edit' src={editIcon} />
                          </Link>}
                          {userData?.usertype === 'job_manager' && offer.candidates_quantity > 0 &&
                          <Link to={'/offers/'+offer.jobpostId+'/details'}>
                            <img className='edit-icon' alt='see' src={openedEyeIcon} />
                          </Link>}
                        </td>
                        <td>
                            {userData?.usertype === 'job_manager' && offer.status === 'active' &&
                                <img className='delete-icon' alt='delete' src={deleteIcon} onClick={() => setSelectedItemToDelete(offer)}  />
                            }
                        </td>
                        {userData?.usertype === 'job_manager' && offer.status !== 'active' &&
                        <td>
                          <Link to={'/offers/create'} state={{ offer_id: offer.jobpostId }}>
                            <img className='duplicate-icon' alt='duplicate' src={duplicateIcon} />
                          </Link>
                        </td>}
                      </tr>
                      )
                    }
                  }/>
                </div>
            </div>
        </div>
        <JobDeleteModal
        jobpost={selectedItemToDelete}
        render={!!selectedItemToDelete}
        onSubmitted={onDeleteJob}
        onClose={() => setSelectedItemToDelete(null)}/>
      </div>
  )
}

export default JobOffers;

export const CircularChart = ({ percentage }: { percentage: number }) => {
  return (
    <svg width={100} height={100} viewBox="0 0 36 36">
      <path className="circle-bg" style={{
         fill: 'none',
         stroke: '#E6E6E6',
         strokeWidth: 2.5
      }}
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        fill="none"
        stroke="#9FD67B"
        strokeWidth="2.5"
        strokeDasharray={`${percentage}, 100`}
        style={{ transition: '0.5s' }}
      />
      <text x="50%" y="50%" textAnchor="middle" fill="black" fontSize="8px" dy=".3em">{percentage}%</text>
    </svg>
  )
}
